import React from 'react'
import dayjs from 'dayjs'
import HTMLReactParser from 'html-react-parser';

import {
    EditOutlined,
    DeleteOutlined
} from '@ant-design/icons'

import { Item } from '../../Item'
import { StyledButton } from '../../Button'

import { useCaseViewContext } from '../../../context'

import { ChartingItem } from './Charting.styles'

import {
    ChartingEntryNote,
    ChartingEntryNoteFooter,
    ButtonGroup
} from './ChartingEntry.styles'

export const ChartingEntry = ({
    item,
    onSelect,
    onDelete
}) => {
    const { provider, apiType } = useCaseViewContext()
    
    const isAuthor = provider?.userId === item.createdBy?._id || 
                     provider?.userId === item.createdBy ||
                     provider?._id === item.createdBy?._id ||
                     provider?._id === item.createdBy
    
    const canEdit = isAuthor && apiType !== 'admin'

    const handleDeleteChartingEntry = () => {
        onDelete(item._id)
    }

    const handleSelectChartingEntry = () => {
        onSelect(item)
    }

    const getAuthorName = () => {
        if (item.createdBy?.name) {
            return `${item.createdBy.name.firstName} ${item.createdBy.name.lastName}`
        }
        if (item.createdBy?.firstName && item.createdBy?.lastName) {
            return `${item.createdBy.firstName} ${item.createdBy.lastName}`
        }
        if (item.createdBy?.name) {
            return item.createdBy.name
        }
        return 'Provider'
    }

    const getFormattedDate = () => {
        const dateValue = item.updatedAt || item.createdAt || item.updatedDate || item.createdDate
        
        if (!dateValue || dateValue === 'N/A') return 'N/A'
        
        try {
            const date = new Date(dateValue)
            if (isNaN(date.getTime())) {
                return 'N/A'
            }
            return dayjs(date).format('MM/DD/YYYY h:mm A')
        } catch (error) {
            console.error('Date formatting error:', error, { dateValue, item })
            return 'N/A'
        }
    }

    return (
        <Item
            key={item._id}
            label={getFormattedDate()}
            value={
                <ChartingItem>
                    <ChartingEntryNote>{HTMLReactParser(item.note)}</ChartingEntryNote>
                    <ChartingEntryNoteFooter>
                        <strong>{getAuthorName()}</strong>
                        {canEdit && (
                            <ButtonGroup>
                                <StyledButton
                                    type="button"
                                    size="small"
                                    color="red"
                                    Icon={DeleteOutlined}
                                    onClick={handleDeleteChartingEntry}
                                />
                                <StyledButton
                                    type="button"
                                    size="small"
                                    Icon={EditOutlined}
                                    onClick={handleSelectChartingEntry}
                                />
                            </ButtonGroup>
                        )}
                    </ChartingEntryNoteFooter>
                </ChartingItem>
            }
        />
    )
}
